import Vue from 'vue';
import { Picker, Popup } from 'vant';

[
  Picker,
  Popup,
].forEach((item) => {
  Vue.use(item);
});
